export default "__VITE_ASSET__CLP5dVZ5__"